import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { OptionCode } from '@cardium/contracts';
import { OptionStore } from '../stores/option.store';

/**
 * Функция, которая создает Гард под конкретный код.
 * Использование: canActivate: [ensureOption(OptionCode.ChatEnabled)]
 */
export function optionGuard(code: OptionCode): CanActivateFn {
  return () => {
    const store = inject(OptionStore);

    // Он сделает запрос и закеширует результат
    return store.rxGetOption(code).pipe(
      take(1),
      map(() => true),
      catchError((err) => {
        console.error(`Не удалось загрузить опцию ${code}`, err);
        return of(true); // Пускаем даже при ошибке (чтобы не ломать навигацию), но логгируем
      }),
    );
  };
}
